export * from './RegisterPage';